
/**
 * Background-image url wrapper, used to avoid breaking the url from special chars
 * @param imageUrl image url
 * @returns formatted/escaped url
 */
const xBackgroundImg = (imageUrl: string) => `url('${imageUrl}')`;

export default xBackgroundImg;
